"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _react2 = require("@jsonforms/react");

var _core = require("@jsonforms/core");

var _materialRenderers = require("@jsonforms/material-renderers");

var _SkipControl = _interopRequireWildcard(require("./SkipControl"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// const NoGroup = withJsonFormsLayoutProps((layout) => <MaterialLayoutRenderer {...layout} />);
// const groupTester = rankWith(3, isGroup);
// const NoLabel = withJsonFormsLayoutProps(() => '');
// const labelTester = rankWith(4, isPlainLabel);
var renderers = [].concat(_toConsumableArray(_materialRenderers.materialRenderers), [// register custom renderers
{
  tester: _SkipControl.tester,
  renderer: _SkipControl["default"]
} // { tester: groupTester, renderer: NoGroup },
// { tester: labelTester, renderer: NoLabel },
]);
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {}
  };
});

var TranslationForm = function TranslationForm(_ref) {
  var formJSON = _ref.formJSON,
      formUIJSON = _ref.formUIJSON,
      data = _ref.data,
      onChange = _ref.onChange,
      classes = _ref.classes;
  var c = useStyles({
    classes: classes
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: c.root
  }, /*#__PURE__*/_react["default"].createElement(_react2.JsonForms, {
    renderers: renderers,
    cells: _materialRenderers.materialCells,
    schema: formJSON,
    uischema: formUIJSON,
    data: data,
    onChange: onChange,
    validationMode: 'NoValidation'
  }));
};

var _default = TranslationForm;
exports["default"] = _default;